var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1233 0.00426156C13.1233 2.00388 13.1233 4.00357 13.1233 6.00319C15.4139 6.00319 17.7045 6.00319 19.9951 6.00319C20.0081 11.6159 19.9951 17.2285 19.9561 22.8411C19.7348 23.3978 19.3054 23.7728 18.6676 23.9659C12.8891 24.0114 7.11056 24.0114 1.33204 23.9659C0.69429 23.7728 0.264805 23.3978 0.0435816 22.8411C-0.0340381 15.5431 -0.00795662 8.24897 0.12167 0.958637C0.380454 0.505397 0.783935 0.198634 1.33204 0.0383464C5.26237 0.00426156 9.19286 -0.00710232 13.1233 0.00426156Z",
    fill: "#2583FB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 0.00390625C15.4416 1.98083 17.7322 3.98045 19.9968 6.00284C17.7062 6.00284 15.4156 6.00284 13.125 6.00284C13.125 4.00322 13.125 2.00353 13.125 0.00390625Z",
    fill: "#0066DA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37793 9.27441C8.12616 9.27441 11.8744 9.27441 15.6226 9.27441C15.6226 9.7289 15.6226 10.1833 15.6226 10.6378C11.8744 10.6378 8.12616 10.6378 4.37793 10.6378C4.37793 10.1833 4.37793 9.7289 4.37793 9.27441Z",
    fill: "#FEFFFE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37793 12.5469C8.12616 12.5469 11.8744 12.5469 15.6226 12.5469C15.6226 13.0014 15.6226 13.4558 15.6226 13.9103C11.8744 13.9103 8.12616 13.9103 4.37793 13.9103C4.37793 13.4558 4.37793 13.0014 4.37793 12.5469Z",
    fill: "#FEFFFE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37793 15.8203C7.08501 15.8203 9.79202 15.8203 12.4991 15.8203C12.4991 16.2748 12.4991 16.7292 12.4991 17.1837C9.79202 17.1837 7.08501 17.1837 4.37793 17.1837C4.37793 16.7292 4.37793 16.2748 4.37793 15.8203Z",
    fill: "#FEFFFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDoc);
export default __webpack_public_path__ + "static/media/GoogleDoc.29e122962c3d8d30930a1686a714c93d.svg";
export { ForwardRef as ReactComponent };